export default {
  themeGreen: '#233539',
  offWhite: '#C8D8DB',
  orange: '#FF5A1E'
}
